/*
  "737 verified reviews" link in the Bible static PDP rating strip.
  Smooth-scrolls to the static Customer Reviews section (#bspdp-reviews) at the end of the
  page; falls back to a Judge.me widget if the static section is ever removed.
*/
document.addEventListener('DOMContentLoaded', () => {
  const link = document.querySelector('.ebms-strip__reviews-link');
  if (!link) return;

  link.addEventListener('click', () => {
    const target =
      document.getElementById('bspdp-reviews') ||
      document.querySelector('.jdgm-rev-widg') ||
      document.querySelector('.jdgm-widget') ||
      document.getElementById('judgeme_product_reviews');

    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});
